import React, { useEffect, useState } from 'react'

import { Snapshot } from 'services/apiTypes/deck.types'

import { useAppSelector } from 'app-redux/hooks'
import { useCanEditDeck } from 'app-redux/deck/selectors'

import DeckService from 'services/deck.service'

import LineLoader from 'components/elements/LineLoader'
import DeckVersionsRow from 'components/deckPage/deckHistory/deckVersionsRow'
import PhatButton from 'components/formElements/PhatButton'
import NewSnapshotForm from 'components/deckPage/deckHistory/newSnapshotForm'

import styles from './deckVersions.module.scss'

const DeckVersions = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [snapshots, setSnapshots] = useState(new Array<Snapshot>())

  const [creating, setCreating] = useState(false)

  const deckId = useAppSelector(state => state.deck.id)
  const canEditDeck = useCanEditDeck()

  const fetchSnapshots = () => {
    setLoading(true)

    DeckService.getSnapshots(deckId)
      .then(setSnapshots)
      .catch(setError)
      .finally(() => setLoading(false))
  }

  useEffect(fetchSnapshots, [])

  if (loading) return <LineLoader />
  if (error) return <div>Some error occured when fetching your decks added and removed cards</div>

  return (
    <div className={styles.container}>
      {canEditDeck && (
        <div className={styles.controls}>
          <PhatButton onClick={() => setCreating(true)} color="green">
            Create deck snapshot
          </PhatButton>
        </div>
      )}

      {creating && (
        <NewSnapshotForm
          onCreated={() => {
            fetchSnapshots()
            setCreating(false)
          }}
          onCancel={() => setCreating(false)}
        />
      )}

      <table className={styles.table}>
        <tbody>
          <tr>
            <th />
            <th>Name</th>
            <th>Created</th>
            <th />
          </tr>
          {snapshots.map((snapshot, index) => (
            <DeckVersionsRow
              snapshot={snapshot}
              key={index}
              otherSnapshots={snapshots.filter(otherSnapshot => otherSnapshot.id !== snapshot.id)}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DeckVersions
